export const DataTable = `
	const rows = [
		{
			key: 1,
			song: 'The Sliding Mr. Bones (Next Stop, Pottersville)',
			artist: 'Malcolm Lockyer',
			year: 1961
		},
		{
			key: 2,
			song: 'Witchy Woman',
			artist: 'The Eagles',
			year: 1972
		},
		{
			key: 3,
			song: 'Shining Star',
			artist: 'Earth, Wind, and Fire',
			year: 1976
		}
	]
	
	const columns = [
		{
			title: 'Song',
			key: 'song'
		},
		{
			title: 'Artist',
			key: 'artist'
		},
		{
			title: 'Year',
			key: 'year'
		}
	]

	<DataTable rows={rows} columns={columns} />
`
